// material-ui
import { MenuOutlined } from '@ant-design/icons';
import { IconButton, useMediaQuery } from '@mui/material';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = ({ handleDrawerToggle }) => {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const iconBackColorOpen = 'grey.300';
  const iconBackColor = 'grey.100';

  return !downLG ? (
    <DrawerHeader open={true} />
  ) : (
    <IconButton
      aria-label="open drawer"
      onClick={handleDrawerToggle}
      edge="start"
      color="secondary"
      variant="light"
      disableRipple
      sx={{ color: 'text.primary', bgcolor: open ? iconBackColorOpen : iconBackColor, ml: 'auto' }}
    >
      <MenuOutlined />
    </IconButton>
  );
};

export default HeaderContent;
